'use client'

import { DataList } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@morpho-org/ui-v6/server'

const VaultConfigurationLoading = () => {
  return (
    <DataList.Root fullWidth>
      <DataList.Column>
        <DataList.Line>
          <Skeleton className="h-md w-[100%] rounded-[20px]" />
        </DataList.Line>
        <DataList.Line>
          <Skeleton className="h-md w-[100%] rounded-[20px]" />
        </DataList.Line>
      </DataList.Column>
      <DataList.Column>
        <DataList.Line>
          <Skeleton className="h-md w-[100%] rounded-[20px]" />
        </DataList.Line>
      </DataList.Column>
    </DataList.Root>
  )
}

export default VaultConfigurationLoading
